import { MouseEventHandler, useCallback, useRef } from "react";
import { useTimelineContext } from "../../context/use-timeline-context";
import { useTimelineSize } from "../../context/use-timeline-size";
import { TrackType } from "../../../../types";
import { IconButton } from "../icon-button";
import { TrashIcon } from "../icons";
import TimelineItem from "../timeline-item";
import { TrackContentWrapper, TrackHeaderWrapper } from "./styled";
import { PlayerRef } from "@remotion/player";

export const TrackHeader = ({
  name,
  handleDeleteTrack,
}: {
  name: string;
  handleDeleteTrack: () => void;
}) => {
  return (
    <TrackHeaderWrapper>
      {name}
      <IconButton
        className={"p-1 opacity-0 group-hover:opacity-75 focus:opacity-75"}
        onClick={handleDeleteTrack}
      >
        <TrashIcon />
      </IconButton>
    </TrackHeaderWrapper>
  );
};

export const TrackContent = ({
  trackIndex,
  track,
  visibleFrames,
  playerRef,
}: {
  trackIndex: number;
  track: TrackType;
  visibleFrames: number;
  playerRef?: React.RefObject<PlayerRef | null>;
}) => {
  const emptySpaceRef = useRef<HTMLDivElement>(null);
  const { setSelectedItem } = useTimelineContext();
  const { timelineWidth } = useTimelineSize();
  const onPointerDownEmptySpace: MouseEventHandler = useCallback(
    (e) => {
      if (e.target === emptySpaceRef.current) {
        setSelectedItem(null);
        return;
      }
    },
    [setSelectedItem]
  );

  return (
    <TrackContentWrapper
      ref={emptySpaceRef}
      onPointerDown={onPointerDownEmptySpace}
    >
      {track.items.map((item) => {
        return (
          <TimelineItem
            key={item.id}
            item={item}
            trackIndex={trackIndex}
            visibleFrames={visibleFrames}
            timelineWidth={timelineWidth}
            playerRef={playerRef}
          />
        );
      })}
    </TrackContentWrapper>
  );
};
